import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseAssignVoucherRequest, UseAssignVoucherData, UseCreateBillingRequest, UseCreateBillingData, UseCreateDirectPaymentRequest, UseCreateDirectPaymentData, UseCreateVoucherRequest, UseCreateVoucherData } from "@api/@types/charge";

export const useAssignVoucher = createApiMutation<UseAssignVoucherData, UseAssignVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.assignVoucher(req as UseAssignVoucherRequest),
});

export const useCreateBilling = createApiMutation<UseCreateBillingData, UseCreateBillingRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.createBilling(req as UseCreateBillingRequest),
});

export const useCreateDirectPayment = createApiMutation<UseCreateDirectPaymentData, UseCreateDirectPaymentRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.createDirectPayment(req as UseCreateDirectPaymentRequest),
});

export const useCreateVoucher = createApiMutation<UseCreateVoucherData, UseCreateVoucherRequest>({
  mutationFn: (req) => apiClientManager.apis.charge.createVoucher(req as UseCreateVoucherRequest),
});

export type { UseAssignVoucherRequest, UseAssignVoucherData, UseCreateBillingRequest, UseCreateBillingData, UseCreateDirectPaymentRequest, UseCreateDirectPaymentData, UseCreateVoucherRequest, UseCreateVoucherData } from "@api/@types/charge";
